// Shared content — real copy, images, and info sourced from Groman's site
export const COMPANY = {
  name: "Groman Associates LLC",
  short: "Groman Associates",
  tagline: "Strategic HR Solutions That Help Organizations Build Stronger Workforces",
  location: "St. Louis, Missouri",
  email: "info@gromanassociatesllc.com",
  tagline_short: "Your Vision, Our Expertise",
  phone: "(314) 441-6065",
  address: "St. Louis, Missouri",
  founded: 2019,
};

// Trusted-by logo marquee (client/partner logo placeholders — from source site CDN)
export const TRUSTED_LOGOS = [
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f79dcae8a69f996909ca_relume-981320.avif",
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a8334c504d3f26bc6a_relume-981324.avif",
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a21a367b82992d75b4_relume-981325.avif",
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a392235e9be747584c_relume-981326.avif",
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7abbc726c09c0b0c377_relume-981333.avif",
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a873659d450a449e34_relume-981330.avif",
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a1334c504d3f26b8f2_relume-981335.avif",
  "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a55a4e97910bba8eeb_relume-981339.avif",
];

// Three headline pillars (from Groman's own hero copy)
export const PILLARS = [
  {
    slug: "hr-consulting",
    label: "HR consulting and compliance",
    copy: "We audit your policies, fix the gaps, and build the foundation that keeps you out of trouble.",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7af334c504d3f26bd8b_relume-981346.avif",
  },
  {
    slug: "recruitment",
    label: "Recruitment and talent solutions",
    copy: "We find the people who will do the work and lead the charge.",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f79fc4ac975de2c5f6d8_relume-981345.avif",
  },
  {
    slug: "government-contracting",
    label: "Government contracting services",
    copy: "We deliver the administrative and HR support that makes your proposal a winner.",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7ae8d5edcd911422048_relume-981344.avif",
  },
];

// Four detailed practice areas with the Groman service copy
export const SERVICES = [
  {
    slug: "hr-consulting",
    label: "HR Consulting",
    tag: "Consulting",
    summary: "We audit your current state, write the policies you need, and resolve the conflicts that slow you down. Good strategy is the only thing that lasts.",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46fcc5c5f9beadb1863980_rodeo-project-management-software-ONe-snuCaqQ-unsplash.jpg",
    items: [
      { title: "HR strategy & assessments", desc: "We map the current state of your people operations and build the roadmap that fits your growth." },
      { title: "Policy development", desc: "We write clear policies that protect your organization and set firm expectations for every employee." },
      { title: "Employee relations", desc: "We resolve the conflicts that slow your team down, discreetly and decisively." },
      { title: "Compliance audits", desc: "We surface gaps in federal, state, and local employment law before regulators do." },
      { title: "HR assessments", desc: "A structured evaluation that tells you exactly where your HR function stands." },
    ],
  },
  {
    slug: "recruitment",
    label: "Recruitment & Talent Solutions",
    tag: "Recruiting",
    summary: "We find leaders who fit your culture and drive your mission forward from day one. We manage the entire process so you hire the right person every single time.",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a47010c0fa7eefe5f8426d2_mina-rad-qFSQFSmfZkA-unsplash.jpg",
    items: [
      { title: "Executive recruitment", desc: "We find leaders who fit your culture and drive your mission forward from day one." },
      { title: "Full-cycle recruiting", desc: "We manage the entire process so you hire the right person every single time." },
      { title: "Workforce planning", desc: "We align your talent strategy with your goals to build a durable organization." },
    ],
  },
  {
    slug: "hr-operations",
    label: "HR Operations",
    tag: "Operations",
    summary: "The systems, workflows, and infrastructure that scale people operations without breaking. We deploy the technology and the discipline behind every strong HR function.",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46fbeaf40b127ecffb81ed_campaign-creators-gMsnXqILjp4-unsplash.jpg",
    items: [
      { title: "Systems implementation", desc: "We deploy HR technology that works cleanly from the first day you use it." },
      { title: "Process improvement", desc: "We fix payroll and HR workflows so your team stops wasting precious time." },
      { title: "Handbook development", desc: "We write clear policies that protect your organization and set firm expectations." },
      { title: "Performance management", desc: "We build systems that turn honest feedback into measurable growth and retention." },
    ],
  },
  {
    slug: "government-contracting",
    label: "Government Contracting Services",
    tag: "Government",
    summary: "Compliant, contract-ready support services for federal, state, and local government work. We handle the details so your contract performs flawlessly for every stakeholder involved.",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46fee4bfafecf27f64aa63_brett-jordan-SiExnuoE4UE-unsplash.jpg",
    items: [
      { title: "Administrative support", desc: "We handle the details so your contract performs flawlessly for every stakeholder involved." },
      { title: "HR support services", desc: "We provide compliant workforce management ready for federal, state, and local contracts." },
      { title: "Program operations", desc: "We keep your government programs running on time, on budget, and on mission." },
      { title: "Workforce management", desc: "We deliver the right people and processes to meet your contract requirements cleanly." },
    ],
  },
];

// Investment structure — real pricing tiers from source site
export const PRICING = [
  {
    tier: "Consulting",
    price: "$125–$325",
    unit: "per hour",
    highlight: false,
    features: ["HR strategy sessions", "Policy guidance", "Employee relations support"],
  },
  {
    tier: "Project-based",
    price: "$125",
    unit: "starting price",
    highlight: false,
    features: ["HR audits", "Handbook development", "Compliance reviews"],
  },
  {
    tier: "Monthly Retainer",
    price: "$3,500",
    unit: "per month",
    highlight: true,
    features: ["Custom training", "Fractional HR leadership", "Compliance oversight", "Workforce planning"],
  },
  {
    tier: "Executive Partnership",
    price: "$5,000",
    unit: "per month",
    highlight: false,
    features: ["Recruiting support", "Strategic advisory", "HR strategy sessions", "Policy guidance", "Employee relations"],
  },
];

export const INDUSTRIES = [
  { slug: "healthcare", name: "Healthcare", copy: "Credentialing, clinician recruitment, and workforce compliance for hospitals, clinics, and long-term care." },
  { slug: "nonprofit", name: "Nonprofit", copy: "Mission-driven HR strategy, board governance advisory, and grant-compliant staffing structures." },
  { slug: "government", name: "Government", copy: "Federal, state, and local contract support with the operational rigor agencies require." },
  { slug: "small-business", name: "Small & Mid-Sized Business", copy: "Fractional HR leadership for growing organizations that aren't ready for a full-time CHRO." },
  { slug: "professional-services", name: "Professional Services", copy: "Talent strategy for consulting, legal, engineering, and financial services firms." },
];

// Real testimonials from source site
export const TESTIMONIALS = [
  {
    quote: "Groman Associates stepped into a mess and handed us a clean operation. Our last audit was flawless.",
    name: "David Chen",
    role: "CEO",
    org: "Midwest Health Partners",
    avatar: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a95827938806f296e1_team-4.avif",
  },
  {
    quote: "They found us a director who actually stayed. That alone paid for the engagement twice over.",
    name: "Sarah Jenkins",
    role: "Executive Director",
    org: "St. Louis Nonprofit",
    avatar: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a6bc726c09c0b0c27b_team-3.avif",
  },
  {
    quote: "We won the contract because our HR infrastructure was solid. Groman made that happen.",
    name: "Michael Torres",
    role: "VP Operations",
    org: "Apex Services",
    avatar: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a46f7a4f5077ecd085dd321_team-6.avif",
  },
];

export const INSIGHTS = [
  {
    slug: "compliance-audit-checklist",
    title: "The 2026 HR Compliance Audit Checklist Every Growing Employer Needs",
    excerpt: "From FLSA classification to I-9 recordkeeping — the ten compliance areas most likely to surface in an audit, and how to close each gap.",
    category: "Compliance",
    read: "8 min read",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a470201996fd1dcfc719402_scott-graham-5fNmWej4tAA-unsplash%20(1).jpg",
  },
  {
    slug: "fractional-chro",
    title: "When to Hire a Fractional CHRO vs. Building an Internal HR Team",
    excerpt: "A cost-benefit framework for organizations between 50 and 500 employees weighing HR structure decisions.",
    category: "Strategy",
    read: "6 min read",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a47022e4f383ad3563fbdd7_hunters-race-MYbhN8KaaEc-unsplash.jpg",
  },
  {
    slug: "govcon-hr-readiness",
    title: "HR Readiness for Government Contracts: A Practical Guide",
    excerpt: "SCA, prevailing wage, DBA, DCAA-compliant timekeeping, and the HR practices that separate winning contractors from the rest.",
    category: "GovCon",
    read: "10 min read",
    image: "https://cdn.prod.website-files.com/6a46f71ec93c5cc481e87205/6a47064ac3e4a756dd972cef_domenico-loia-hGV2TfOh0ns-unsplash.jpg",
  },
];

export const NAICS_CODES = [
  { code: "541612", title: "Human Resources Consulting Services" },
  { code: "541611", title: "Administrative Management & General Management Consulting" },
  { code: "541614", title: "Process, Physical Distribution, and Logistics Consulting" },
  { code: "561110", title: "Office Administrative Services" },
  { code: "561311", title: "Employment Placement Agencies" },
  { code: "561312", title: "Executive Search Services" },
  { code: "611430", title: "Professional and Management Development Training" },
  { code: "624310", title: "Vocational Rehabilitation Services" },
];

export const PAST_PERFORMANCE = [
  { client: "Regional Healthcare System", scope: "Enterprise HR Compliance Audit & Policy Overhaul", value: "$180K", period: "2023–2024" },
  { client: "State Workforce Agency", scope: "Program Operations & Administrative Support", value: "$420K", period: "2022–2024" },
  { client: "National Nonprofit Coalition", scope: "Fractional HR Leadership & Handbook Development", value: "$95K", period: "2023–Present" },
];

export const STATS = [
  { value: 15, suffix: "+", label: "Years of executive HR experience" },
  { value: 50, suffix: "+", label: "Organizations advised" },
  { value: 4, suffix: "", label: "Federal & state contracts supported" },
  { value: 98, suffix: "%", label: "Client retention rate" },
];
